var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDashClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.749,
    height: 24.749,
    viewBox: "0 0 24.749 24.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Dash",
    "data-name": "Menu Dash",
    transform: "translate(-39 -109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2736",
    "data-name": "Rectangle 2736",
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "translate(42.536 109) rotate(45)",
    fill: "#fd9543"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "translate(42.536 109) rotate(45)",
    fill: "#fd9543"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2738",
    "data-name": "Rectangle 2738",
    width: 30,
    height: 5,
    rx: 2.5,
    transform: "translate(39 130.213) rotate(-45)",
    fill: "#fd9543"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashClose);
export default __webpack_public_path__ + "static/media/MenuDashClose.c07b9d4590c57dc6405a58a80e78bddd.svg";
export { ForwardRef as ReactComponent };